module.exports = __webpack_public_path__ + "img/meta.a2e76f32.png";